import React, { forwardRef, useState } from 'react';

import '../styles/InputPlace.css';

import { ReactComponent as AssetIcon } from '../resources/assets/iconCombo.svg'; 

const InputPlace = forwardRef(({ value, onChange, placeholder, label, disabled=false}, ref) => {

  return (
    <div className="input-place-wrapper">
      {label && <label className="input-place-label">{label}</label>} 
        <div
            ref={ref}
            className="input-place-normal"
            onChange={(e) => onChange(e.target.value)}
        >
            {!value ? <div className="input-place-placeholder">{placeholder}</div> : "" }
        </div>
        <button className="input-place-icon"><AssetIcon height={"75%"} /></button> 
      </div>
  ); 
});

export default InputPlace;